import { IGetState, TCardId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { uploadFiles } from '../effects/uploadFiles';
import { attachmentPastedSegmentEvent, attachmentPasteErrorSegmentEvent } from '../effects/segmentEffects';
import { SegmentCardPasteFileTarget } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { snackbarErrorReload } from 'app/view/react_components/snackbarsStack';

export const onPasteFile = (
    cardId: TCardId,
    files: File[],
    onProgress: (percent: number) => void
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (!files) {
            return dispatch(attachmentPasteErrorSegmentEvent(SegmentCardPasteFileTarget.CARD));
        }

        dispatch(attachmentPastedSegmentEvent(SegmentCardPasteFileTarget.CARD));
        return dispatch(uploadFiles(cardId, files, onProgress, true))
            .catch((e: any)=>{
                dispatch(snackbarErrorReload(true, `Error: ${e.message? e.message: JSON.stringify(e)}`));
            });
    };
    return action;
};
